import { Box } from '@material-ui/core'

import { DragDropContext, Droppable } from 'react-beautiful-dnd'
import { SelectedLayers } from './SelectedLayers'

import { useGlobalContext, orderLayersChange } from '../../state'

export const SelectedExternalLayers = ({ visibility }) => {
  const {
    state: { layers, language },
    dispatch
  } = useGlobalContext()

  return (
    <DragDropContext
      onDragEnd={(result) => {
        const { source, destination } = result
        if (destination) {
          dispatch(
            orderLayersChange({
              startIndex: source.index,
              endIndex: destination.index
            })
          )
        }
      }}
    >
      <Droppable droppableId="layers">
        {(droppableProvided) => (
          <Box
            {...droppableProvided.droppableProps}
            ref={droppableProvided.innerRef}
            className="layer-container"
            style={{
              display: visibility ? '' : 'none'
            }}
          >
            <SelectedLayers layers={layers} language={language} />
            {droppableProvided.placeholder}
          </Box>
        )}
      </Droppable>
    </DragDropContext>
  )
}
